import Skeleton from '@srm/ui/skeleton';
import ContentSurface from '@srm/ui/content-surface';
import '../Reports.scss';
import './ReportSkeleton.scss';

/**
 * Каркас страницы отчёта. Повторяет её раскладку теми же классами — шапка, чипы периода,
 * поля с кнопкой и холст во всю ширину, — чтобы при появлении формы ничего не прыгало.
 *
 * Ленту запусков каркас не изображает: есть ли у отчёта прошлые запуски, до ответа
 * сервера неизвестно, а пустая полоса на её месте — обещание, которое некому сдержать.
 */
const ReportSkeleton = ({ name = '' }: { name?: string }) => (
    <div className="report-page">
        <div className="report-page__head">
            <p className="report-page__section">Отчёты</p>
            <div className="report-page__title-row">
                <h1 className="report-page__title">{name}</h1>
                <span className="report-page__favorite-slot" aria-hidden />
            </div>
        </div>

        <div className="report-page__fold">
            <div className="report-page__fold-inner">
                <div className="report-skeleton__chips" aria-hidden>
                    {[112, 108, 120, 104].map((width, index) => (
                        <Skeleton key={index} height={26} width={width} radius={13} />
                    ))}
                </div>
                <div className="report-params">
                    <div className="report-params__fields">
                        <div
                            className="report-skeleton"
                            role="status"
                            aria-label="Загрузка параметров отчёта"
                            aria-busy="true"
                        >
                            {[0, 1].map((index) => (
                                <div className="report-skeleton__field" key={index} aria-hidden>
                                    <Skeleton height={14} width={100 + index * 20} radius={5} />
                                    <Skeleton height={40} radius={8} />
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className="report-params__action report-skeleton__action" aria-hidden>
                        <Skeleton height={32} width={104} radius={7} />
                    </div>
                </div>
            </div>
        </div>

        <ContentSurface className="report-canvas" data-state="empty" aria-hidden />
    </div>
);

export default ReportSkeleton;
